import { useState } from "react";
import { Banknote } from "lucide-react";

const reais = (v) => `R$ ${Number(v || 0).toFixed(2).replace(".", ",")}`;

/**
 * Faixa no topo da tela Delivery: pedidos em dinheiro entregues pela UP Entrega
 * em que o entregador espera a loja confirmar o recebimento. Dois toques (pergunta
 * "recebeu?") porque confirmar libera o entregador e não tem volta.
 */
export default function AvisoDinheiroUP({ itens, confirmando, onConfirmar }) {
  const [perguntando, setPerguntando] = useState(null);
  if (!itens || itens.length === 0) return null;

  return (
    <div data-testid="aviso-dinheiro-up" className="mx-1 sm:mx-2 md:mx-3 lg:mx-4 mt-1 rounded-xl border border-amber-500/40 bg-amber-500/10 px-3 py-2 space-y-1.5">
      <p className="text-xs font-semibold text-amber-700 dark:text-amber-400 flex items-center gap-1.5">
        <Banknote className="w-4 h-4 shrink-0" />
        Dinheiro a confirmar — UP Entrega
      </p>
      {itens.map(({ pedido, estado }) => {
        const voltando = (estado.entregaai_status || "").toLowerCase() === "returning";
        const nome = estado.entregaai_driver_name || pedido.entregador_nome || "Entregador";
        const ocupado = confirmando === pedido.id;
        return (
          <div key={pedido.id} data-testid={`dinheiro-up-${pedido.id}`} className="flex flex-wrap items-center gap-x-3 gap-y-1.5">
            <div className="min-w-0 flex-1 text-xs">
              <span className="font-semibold">{pedido.codigo || String(pedido.id).slice(0, 8)}</span>
              <span className="text-muted-foreground"> · {pedido.cliente_nome || "Cliente"} · </span>
              <span className="font-semibold tabular-nums">{reais(pedido.total)}</span>
              <span className={voltando ? "block sm:inline sm:ml-2 text-amber-700 dark:text-amber-400 font-medium" : "block sm:inline sm:ml-2 text-muted-foreground"}>
                {voltando ? `${nome} voltando com o dinheiro` : `${nome} em entrega`}
              </span>
            </div>
            {perguntando === pedido.id ? (
              <div className="flex items-center gap-1.5 shrink-0">
                <span className="text-xs">Recebeu {reais(pedido.total)}?</span>
                <button
                  type="button"
                  disabled={ocupado}
                  onClick={() => { setPerguntando(null); onConfirmar(pedido.id); }}
                  className="px-2.5 h-7 rounded-md bg-emerald-600 hover:bg-emerald-700 text-white text-xs font-semibold disabled:opacity-60"
                >
                  Sim, recebi
                </button>
                <button type="button" onClick={() => setPerguntando(null)} className="px-2 h-7 rounded-md border text-xs hover:bg-muted">
                  Voltar
                </button>
              </div>
            ) : (
              <button
                type="button"
                disabled={ocupado}
                onClick={() => setPerguntando(pedido.id)}
                className={`shrink-0 px-2.5 h-7 rounded-md text-xs font-semibold disabled:opacity-60 ${voltando ? "bg-amber-500 hover:bg-amber-600 text-white" : "border border-amber-500/50 text-amber-700 dark:text-amber-400 hover:bg-amber-500/10"}`}
              >
                {ocupado ? "Confirmando..." : "Confirmar recebimento"}
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}
